function getReputationState(state) {
  return {
    ratings: state.reputation.ratings,
    loadingRatings: state.reputation.loadingRatings,
    hasRatings: state.reputation.hasRatings,
    ratingsError: state.reputation.ratingsError,
    reports: state.reputation.reports,
    loadingReports: state.reputation.loadingReports,
    hasReports: state.reputation.hasReports,
    reportsError: state.reputation.reportsError,
    quality: state.reputation.quality,
    loadingQuality: state.reputation.loadingQuality,
    hasQuality: state.reputation.hasQuality,
    qualityError: state.reputation.qualityError,
    branches: state.reputation.branches,
    customersComments: state.reputation.customersComments
  };
}

export { getReputationState };
